/** Block-action name registered while the Bemessung (design) form has unsaved changes. */
export const RESULTS2_DESIGN_FORM_BLOCK_ACTION = 'results2-design-form'

/** Shown when navigation away from Bemessung is blocked due to unsaved form changes. */
export const UNSAVED_BEMESSUNG_NAV_MESSAGE =
  'Bitte speichern Sie zuerst die Bemessung, bevor Sie die Ansicht wechseln.'

/** Stable notistack key so the warning can be dismissed after Rückgängig / Speichern. */
export const UNSAVED_BEMESSUNG_NAV_SNACKBAR_KEY = 'results2-unsaved-bemessung-nav'

/** Element types the inner-forces plot endpoint supports (`supportedElementTypes` in
 * server/src/md_core/server/routers/checks.py). */
export const ELEMENT_TYPES_WITH_INNER_FORCES_PLOT: ElementTypes[] = [
  'beams',
  'purlins',
  'slab_beams',
  'roof_slab_beams',
]

export const unsavedBemessungNavSnackbarOptions = {
  variant: 'warning' as const,
  preventDuplicate: true,
  key: UNSAVED_BEMESSUNG_NAV_SNACKBAR_KEY,
}

export const SHEAR_CHECK_TYPES = new Set<MemberCheckType>([
  'TwoWayShearStress',
  'ShearStressY',
  'ShearStressZ',
  'TwoWayShearStressCLTParallelLayer',
  'TwoWayShearStressCLTOrthogonalLayer',
  'TwoWayShearStressHot',
  'TwoWayShearStressCLTParallelLayerHot',
  'TwoWayShearStressCLTOrthogonalLayerHot',
])

/** Checks flagged with the relevance dot when the Heißbemessung settings tab is active. */
export const HOT_DIMENSIONING_MEMBER_TYPES = new Set<MemberCheckType>([
  'HotDimensioning',
  'HotDimensioningCLT',
  'BendingYZHot',
  'BendingWithTensionHot',
  'BendingWithCompressionHot',
  'TensionOnlyHot',
  'CompressionOnlyHot',
  'TwoWayShearStressHot',
  'TwoWayShearStressCLTParallelLayerHot',
  'TwoWayShearStressCLTOrthogonalLayerHot',
])

/** Checks flagged with the relevance dot when the Fußpunkt (steel) settings tab is active. */
export const STEEL_FUSSPUNKT_MEMBER_TYPES = new Set<MemberCheckType>([
  'SteelCompression',
  'SteelSupportCompression',
  'SteelBasicCheck',
  'SteelBasePlateWeld',
  'SteelDisplacement',
])

/** Light green row highlight used in Nachweise and Auflager selection. */
export const RESULTS2_DETAIL_ROW_HIGHLIGHT_BG = 'rgba(55,132,52,0.08)'

export const SUPPORTS_GRID_COLS =
  '24px minmax(100px,1fr) 40px minmax(46px,0.3fr) 40px minmax(78px,0.9fr) minmax(92px,0.85fr) 60px minmax(76px,1fr)'

/** Shared grid layout for SupportsGrid header and SupportGridRow. */
export const supportsGridLayoutSx = {
  display: 'grid',
  gridTemplateColumns: SUPPORTS_GRID_COLS,
  gap: 0.75,
  alignItems: 'stretch',
  '& > *': {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  '& > *:not(:first-of-type)': {
    borderLeft: '1px solid',
    borderColor: 'divider',
    pl: 0.75,
  },
} as const

// Backend stores support geometry in base units; this form displays/edits in cm.
export const SUPPORT_GEOM_DISPLAY_FACTOR = 100

// Matches CSAndAPPopup FC90KField: stored Pa → display N/mm²
export const FC90K_CONVERSION_FACTOR = 1_000_000
